import { useMemo } from 'react';

import Config from '@config';
import {
  MeteringDeviceGroup,
  enumOptions,
  initializeMeteringDeviceGroupsApi,
} from '@gasbi/shared';
import { useTranslation } from 'react-i18next';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const meteringDeviceGroups = initializeMeteringDeviceGroupsApi({
  baseUrl: Config.VITE_API_CLIENT_URL,
  baseQuery: axiosBaseQuery,
});

export const {
  useGetCompatibleMeteringDeviceGroupsQuery,
  meteringDeviceGroupsApi,
} = meteringDeviceGroups;

/**
 * Options of the «Група приладу» picker of the Households device forms: the MeteringDeviceGroup members BMS finds
 * compatible with the kind of вузол обліку, in enum order, with the Enum.MeteringDeviceGroup.* labels (Epic GSB-8400,
 * PO 2026-11-02).
 */
export const useMeteringDeviceGroupOptionsQuery = ({
  nodeType,
}: {
  nodeType?: string;
}) => {
  const { t } = useTranslation();
  const result = useGetCompatibleMeteringDeviceGroupsQuery(
    nodeType ? { nodeType } : undefined,
  );

  const data = useMemo(
    () =>
      enumOptions(t, 'MeteringDeviceGroup', MeteringDeviceGroup).filter(
        option => result.data?.includes(option.id),
      ),
    [result.data, t],
  );

  return { ...result, data };
};
